// extracted by mini-css-extract-plugin
export const details = "project-details-module--details--1tNzN";
export const htmldiv = "project-details-module--htmldiv--M3cCG";
export const featured = "project-details-module--featured--3OUDF";